import { format } from "date-fns";
import { es } from "date-fns/locale";
import { toast } from "sonner";
import { MessageCircle, Printer } from "lucide-react";
import { api, errMsg, waLink, TIPOS_CITA } from "@/lib/api";

export const fechaLarga = (f) => format(new Date(`${f}T12:00`), "EEEE d 'de' MMMM", { locale: es });
const centroTxt = (c) => (c === "MADRID" ? "Madrid" : c === "ALCOBENDAS" ? "Alcobendas" : "");

export const ProximasCitas = ({ patient }) => {
  const wa = async () => {
    try {
      const { data } = await api.get(`/patients/${patient.id}/proximas-citas`);
      if (!data.citas.length) return toast.info("No tiene citas próximas");
      if (!data.patient.telefono) return toast.error("Este paciente no tiene teléfono en su ficha");
      const lineas = data.citas.map((c) => `• ${fechaLarga(c.fecha)} a las ${c.inicio} · ${TIPOS_CITA[c.tipo]?.label || ""}${c.centro ? ` (${centroTxt(c.centro)})` : ""}`);
      const msg = `Hola, os recordamos las próximas citas de ${data.patient.nombre} en Salud y Visión:\n${lineas.join("\n")}\n\nSi no podéis venir a alguna, avisadnos por favor. ¡Gracias!`;
      window.open(waLink(data.patient.telefono, msg), "_blank");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const btn = "inline-flex items-center gap-1 rounded-md border px-2.5 h-9 text-xs font-medium transition-colors";
  return (
    <>
      <button type="button" onClick={wa} data-testid="appt-familia-wa" className={`${btn} border-emerald-300 text-emerald-700 hover:bg-emerald-50`}><MessageCircle className="h-3.5 w-3.5" />Próximas citas</button>
      <a href={`/pacientes/${patient.id}/proximas-citas`} target="_blank" rel="noreferrer" data-testid="appt-familia-print" className={`${btn} border-slate-300 text-slate-700 hover:bg-slate-50`} title="Imprimir próximas citas"><Printer className="h-3.5 w-3.5" /></a>
    </>
  );
};
